
import React from "react";
import "./errorcounter.scss";

class ErrorCounter extends React.Component {

    render() {

        if ( !this.props.maxErrors ) {

            return "";

        }

        const classNamesArray = [ "ErrorCounter" ];

        if ( this.props.className ) {

            classNamesArray.push( this.props.className );

        }

        const classNamesString = classNamesArray.join( " " );

        const dots = [];

        for ( let i = 0; i < this.props.maxErrors; i++ ) {

            dots.push( <div key={ i } className={ i < this.props.errors ? "Dot Filled" : "Dot" } /> );

        }

        return (

            <div className={ classNamesString }>

                { dots }

            </div>

        );

    }

}

ErrorCounter.defaultProps = {

    className: "",
    errors: 0,
    maxErrors: 0

};

export default ErrorCounter;